import React, { useEffect, useRef, useState } from "react";
import {
  ActionBtns,
  Btn,
  Content,
  ContentWrapper,
  Dates,
  DDContent,
  DDButton,
  ExtraActions,
  Header, HeaderWrapper, IconWrapper,
  Title,
  Wrapper
} from "./draftChapter.styles";
import { DownOutlined, EllipsisOutlined } from "@ant-design/icons";
import Dropdown from "components/atoms/Dropdown/dropdown";
import { ChapterEditorDataProvider } from "contexts/ChapterEditorContext";
import Editor from "../../editor/Editor";
import { useWallDataContext } from "contexts/WallContext";
import { useTranslation } from "react-i18next";
import { IDraftChapter } from "models/wall";
import { AnimatePresence, motion } from "framer-motion";
import DraftParagraph from "../Paragraph/draftParagraph";
import RemoveIcon from "@assets/icons/remove-red.svg";
import { formatedDate } from "utils";


function DraftChapter({chapter}: {chapter: IDraftChapter}) {
  const { t } = useTranslation();
  const { removeDraftChapter, draftChapters, chapters } = useWallDataContext();
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [isContentOpen, setIsContentOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);

  const onDelete = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation();
    if (!chapter.uuid) return;
    removeDraftChapter(chapter.uuid);
  }

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isContentOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isContentOpen]);

  const toggleActions = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setActionsOpen(p => !p);
  }

  const openEditor = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation();
    setIsEditorOpen(true);
    setActionsOpen(false);
  };

  const dropdownOnTop = draftChapters[draftChapters.length - 1].uuid === chapter.uuid && chapters.length === 0;
  const fromDate = formatedDate(chapter.date_from_year, chapter.date_from_month, chapter.date_from_day);
  const toDate = formatedDate(chapter.date_to_year, chapter.date_to_month, chapter.date_to_day)

  return (
    <>
      <Wrapper>
        <HeaderWrapper onClick={() => setIsContentOpen(p => !p)}>
          <Header>
            <Dates>
              {fromDate}
              {fromDate && toDate && " - "}
              {toDate}
            </Dates>
            <ActionBtns>
              <ExtraActions>
                <Btn style={{color: "#391D0A"}} onClick={toggleActions}>
                  <EllipsisOutlined/>
                </Btn>
                <Dropdown top={dropdownOnTop} isOpen={actionsOpen} onClose={() => setActionsOpen(false)}>
                  <DDContent>
                    <DDButton onClick={openEditor}>{t('wall.edit')}</DDButton>
                    <DDButton style={{color: 'rgba(201, 54, 54, 1)'}} onClick={onDelete}>
                      {t('wall.delete')} <img src={RemoveIcon} alt="remove"/>
                    </DDButton>
                  </DDContent>
                </Dropdown>
              </ExtraActions>
              <Btn>
                <IconWrapper isOpen={isContentOpen}><DownOutlined /></IconWrapper>
              </Btn>
            </ActionBtns>
          </Header>
          <Title>{chapter.title}</Title>
        </HeaderWrapper>

        <ContentWrapper style={{ height: `${height}px`, opacity: 0.5 }}>
          <Content ref={contentRef}>
            <AnimatePresence>
              {chapter.draft_paragraphs.filter(p => !p.is_deleted).map((p) => (
                <motion.div
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  key={p.uuid}
                >
                  <DraftParagraph key={p.uuid} paragraph={p}/>
                </motion.div>
              ))}
            </AnimatePresence>
          </Content>
        </ContentWrapper>
      </Wrapper>

      {isEditorOpen && chapter.story && (
        <ChapterEditorDataProvider storyId={chapter.story} initialDraft={chapter}>
          <Editor isOpen={isEditorOpen} onClose={() => setIsEditorOpen(false)} />
        </ChapterEditorDataProvider>
      )}
    </>

  );
}

export default DraftChapter;
